import { render } from "./swiper.vue?vue&type=template&id=2cc338a3"
import script from "./swiper.vue?vue&type=script&lang=js"
export * from "./swiper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/component/swiper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cc338a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cc338a3', __exports__)) {
    api.reload('2cc338a3', __exports__)
  }
  
  module.hot.accept("./swiper.vue?vue&type=template&id=2cc338a3", () => {
    api.rerender('2cc338a3', render)
  })

}


export default __exports__